import React from 'react';
import * as xlsx from "xlsx";


export function useStreamedReportDownloads(props) {

    const {
        url = "",
    } = props;

    const [downloadedRows, setDownloadedRows] = React.useState(0);

    async function downloadReport(data, callback) {

        setDownloadedRows(0);

        const response = await fetch(process.env.REACT_APP_API_URL + url, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify(data),
            mode: "cors"
        });

        if (response.body) { } else {
            throw new Error();
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = null;

        const rows = [];

        // Process the response stream
        while (true) {

            const {
                done,
                value
            } = await reader.read();

            if (done) {
                break;
            }

            // Decode and accumulate chunk into buffer
            const chunk = decoder.decode(value, { stream: true });
            buffer = buffer === null ? chunk : buffer + chunk;

            const lines = buffer.split('\n');

            for (let i = 0; i < lines.length - 1; i++) {

                const line = lines[i];

                const chunkRows = JSON.parse(
                    line
                );

                rows.push(
                    ...chunkRows
                );

                setDownloadedRows(rows.length);

            }

            buffer = lines[lines.length - 1];
            if (0 < buffer.length) { } else {
                buffer = null;
            }
        }

        if (buffer === null) { } else {

            const chunkRows = JSON.parse(
                buffer
            );

            rows.push(
                ...chunkRows
            );

            setDownloadedRows(
                rows.length
            );
        }

        setTimeout(() => {

            const workbook = xlsx.utils.book_new();

            const sheet = xlsx.utils.aoa_to_sheet(rows);
            xlsx.utils.book_append_sheet(workbook, sheet, data.title);

            xlsx.writeFile(workbook, data.title + ".xlsx", {

            });

            if (callback) {
                callback(null)
            }

        }, 100);
    }

    return {
        downloadedRows,
        downloadReport
    }

}
